import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import useAuth from "../api/auth";
import authStorage from "../utils/authStorage";
import userStorage from "../utils/userStorage";
import { useSnackbar } from "notistack";

const useLogin = (option: boolean) => {
  // const { data: webUpdateData } = useGetWebUpdate(); // 점검중 확인
  const { login } = useAuth();
  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();

  // let isUpdatingTime =
  //   webUpdateData &&
  //   new Date(webUpdateData.result.start_date) <= new Date() &&
  //   new Date(webUpdateData.result.end_date) >= new Date();

  const mutation = useMutation({
    mutationFn: login,
    onSuccess: async (data) => {
      // if (webUpdateData && isUpdatingTime && data.grade !== 2) {
      //   alert(`점검중입니다.`);
      //   logOut();
      //   navigate(`/maintenance`, {
      //     replace: true,
      //   });
      //   return;
      // } else {
      //   userStorage.set({ ...data, keepLoggedIn: option });
      //   const { accessToken, refreshToken } = data;
      //   authStorage.set({ accessToken, refreshToken });
      //   navigate(`/`);
      //   enqueueSnackbar(`${data.name}님! 안녕하세요.`, {
      //     variant: "success",
      //     anchorOrigin: {
      //       vertical: "top",
      //       horizontal: "center",
      //     },
      //   });
      // }
      userStorage.set({ ...data, keepLoggedIn: option });
      const { accessToken, refreshToken } = data;
      authStorage.set({ accessToken, refreshToken });
      navigate(`/`);
      enqueueSnackbar(`${data.name}님! 안녕하세요.`, {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
    },
    onError: (error) => {
      if (error.response?.data.code === 4010) {
        window.alert(error.response?.data.message);
        return;
      }
      if (error.response?.data.code !== 4009) {
        enqueueSnackbar(
          `로그인에 실패하였습니다. 잠시 후에 다시 시도해 주세요.`,
          {
            variant: "error",
          }
        );
        return;
      }
      return error;
    },
  });

  return mutation;
};

export default useLogin;
